import { AppointmentStatus, BankGateway, MerchantAppointmentQueueDto, PaymentType } from "@/models/club";
import { bankGatewayLabel } from "./bankGateway";

export const paymentTypeLabel = (appointment: MerchantAppointmentQueueDto) => {
  const method = appointment.bankGateway === BankGateway.Value4 ? "اسنپ‌پی" : `آنلاین · ${bankGatewayLabel(appointment.bankGateway)}`;
  if (appointment.paymentType === PaymentType.Value0) return method;
  if (appointment.paymentType === PaymentType.Value1) return `${method} · بیعانه`;
  return "ثبت‌شده توسط سالن";
};

export const paymentMethodColor = (appointment: MerchantAppointmentQueueDto) =>
  appointment.bankGateway === BankGateway.Value4 ? "violet" :
  appointment.paymentType === PaymentType.Value1 ? "orange" :
  appointment.paymentType === PaymentType.Value0 ? "blue" : "gray";

export const isSuccessfulAppointmentPayment = (
  appointment: MerchantAppointmentQueueDto,
) =>
  appointment.status === AppointmentStatus.Value1 &&
  !!appointment.paymentInfo;
export const paymentStatusInfo = (appointment: MerchantAppointmentQueueDto) => {
  const gateway = bankGatewayLabel(appointment.bankGateway);
  // Preserve the appointment status mapping used by the merchant report.
  // Terminal statuses take precedence over a retained transaction record.
  if (appointment.status === AppointmentStatus.Value3) {
    return { label: "پرداخت ناموفق", description: "پرداخت با موفقیت انجام نشده است", color: "red" };
  }
  if (appointment.status === AppointmentStatus.Value4) {
    return { label: "بازگشت داده شده", description: "مبلغ پرداخت به مشتری برگشت داده شده است", color: "orange" };
  }
  if (appointment.status === AppointmentStatus.Value2) {
    return { label: "لغو شده", description: "نوبت لغو شده است", color: "gray" };
  }
  if (isSuccessfulAppointmentPayment(appointment)) {
    return { label: "پرداخت شده", description: `پرداخت موفق با ${gateway}`, color: "green" };
  }
  if (appointment.paymentInfo) {
    return { label: "تراکنش ثبت شده", description: "پرداخت هنوز نهایی نشده است", color: "yellow" };
  }
  if (appointment.needPayment) {
    return { label: "در انتظار پرداخت", description: `در انتظار پرداخت با ${gateway}`, color: "yellow" };
  }
  return { label: "پرداخت ثبت نشده", description: "اطلاعات پرداخت درگاه موجود نیست", color: "gray" };
};
